// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__1CyqF","marqueeContainer":"Contact_marqueeContainer__Sx3H3","marquee":"Contact_marquee__63xuh"};